module.exports = __webpack_public_path__ + "static/media/F1.c68d275b.png";